import { NavLink } from 'react-router-dom';
import React, { useEffect, useState } from 'react';
import DefaultSEO from './DefaultSEO';
const homeUrl = process.env.REACT_APP_HOME_URL;
const adminApiUrl = process.env.REACT_APP_ADMIN_API_URL;

const stripHtml = (html) => {
  const tempDiv = document.createElement('div');
  tempDiv.innerHTML = html;
  return tempDiv.textContent || tempDiv.innerText || '';
};

const Guides = () => {
  const [guides, setGuides] = useState([]);
  const [visibleCount, setVisibleCount] = useState(12);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetch(`${adminApiUrl}/guides`)
      .then(response => response.json())
      .then(data => setGuides(data))
      .catch(error => console.error('Error fetching guides:', error))
      .finally(() => setLoading(false));
  }, []);

  const handleLoadMore = () => {
    setVisibleCount((prevCount) => prevCount + 12);
  };

  const renderSkeletons = () => {
    return Array.from({ length: 6 }).map((_, i) => (
      <div key={i} className="col-sm-12 col-md-4 col-lg-4 col-xl-4">
        <div className="articals_mainbox">
          <div className="articals_imgbox">
            <div className="skeleton skeleton-thumbnail"></div>
          </div>
          <div className="articals_contntbox">
            <div className="artical_info">
              <div className="skeleton skeleton-small-text mb-2"></div>
            </div>
            <div className="artical_contnt">
              <div className="skeleton skeleton-title mb-2"></div>
              <div className="skeleton skeleton-text"></div>
              <div className="skeleton skeleton-text"></div>
            </div>
          </div>
        </div>
      </div>
    ));
  };

  return (
     <>
   <DefaultSEO />

    <div className="blogs_wrapper">
      <div className="articals_mainsec">
        <div className="container">
          <div className="row">
            <div className="col-sm-12 col-md-12 col-lg-12 col-xl-12">
              <div className="title_mainsec">
                <h2>Guides</h2>
              </div>
            </div>
          </div>

          <div className="row">
            {loading
              ? renderSkeletons()
              : guides.slice(0, visibleCount).map((guide) => (
                  <div key={guide.id} className="col-sm-12 col-md-4 col-lg-4 col-xl-4">
                    <div className="articals_mainbox">
                      <div className="articals_imgbox">
                        <img
                          alt={guide.title}
                          src={
                            guide.image
                              ? `${homeUrl}/admin/public/storage/${guide.image}`
                              : `${homeUrl}/admin/public/storage/default.jpg`
                          }
                        />
                      </div>

                      <div className="articals_contntbox">
                        <div className="artical_info">
                          <span className="time_txt">
                            {new Date(guide.created_at).toLocaleDateString('en-GB', {
                              day: 'numeric',
                              month: 'long',
                              year: 'numeric'
                            })}
                          </span>
                        </div>

                        <div className="artical_contnt">
                          <h3>
                            <NavLink to={`/guides/${guide.slug}`}>
                              {guide.title}
                            </NavLink>
                          </h3>
                          <p>{stripHtml(guide.content).substring(0, 100)}...</p>
                        </div>
                      </div>
                    </div>
                  </div>
                ))}
          </div>

          {!loading && visibleCount < guides.length && (
            <div className="row">
              <div className="col-sm-12 col-md-12 col-lg-12 col-xl-12">
                <div className="btn_mainsec">
                  <button onClick={handleLoadMore} className="btn_style">Load More</button>
                </div>
              </div>
            </div>
          )}
        </div>
      </div>
    </div>
       </>
  );
};

export default Guides;
